

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    const { NotificationsTray } = await import('@edx/frontend-plugin-notifications');
    addPlugins(config, 'org.openedx.frontend.layout.header_desktop_secondary_menu.v1', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'notification-drawer-widget',
        priority: 10,
        type: DIRECT_PLUGIN,
        RenderWidget: NotificationsTray,
      },
    }
]);
    addPlugins(config, 'org.openedx.frontend.layout.header_learning_help.v1', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'notification-drawer-widget',
        priority: 10,
        type: DIRECT_PLUGIN,
        RenderWidget: NotificationsTray,
      },
    }
]);
    addPlugins(config, 'org.openedx.frontend.layout.studio_header_search_button_slot.v1', [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'notification-drawer-widget',
        priority: 10,
        type: DIRECT_PLUGIN,
        RenderWidget: NotificationsTray,
      },
    }
]);
    if (process.env.APP_ID == 'admin-console') {
    }
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {


      const { CourseOutlineSidebar, UnitPageSidebar, SidebarToggleWrapper, CourseHeaderButton, UnitActionsButton, SubSectionAnalyticsButton } = await import("@openedx/frontend-plugin-aspects");


await import("@openedx/openedx-ai-badges-ui");
const { ConfigurableAIAssistance, AIExtensionsCard } = await import("@openedx/openedx-ai-extensions-ui");
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_sidebar.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'outline-sidebar',
                    priority: 1,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseOutlineSidebar,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_sidebar.v1', [
            {
                op: PLUGIN_OPERATIONS.Wrap,
                widgetId: 'default_contents',
                wrapper: SidebarToggleWrapper,
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'course-unit-sidebar',
                    priority: 1,
                    type: DIRECT_PLUGIN,
                    RenderWidget: UnitPageSidebar,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
            {
                op: PLUGIN_OPERATIONS.Wrap,
                widgetId: 'default_contents',
                wrapper: SidebarToggleWrapper,
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_header_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'unit-header-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseHeaderButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_header_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'outline-header-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseHeaderButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_unit_card_extra_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'units-action-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: UnitActionsButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_subsection_card_extra_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'units-action-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: SubSectionAnalyticsButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
          {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'ai-assist-button-course-outline-sidebar',
                priority: 60,
                type: DIRECT_PLUGIN,
                RenderWidget: ConfigurableAIAssistance,
            },
          }]);
      addPlugins(config, 'org.openedx.frontend.authoring.additional_course_plugin.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'ai-extensions-settings-card',
                    type: DIRECT_PLUGIN,
                    RenderWidget: AIExtensionsCard
                },
            }]);
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
    }
    if (process.env.APP_ID == 'learning') {const { ConfigurableAIAssistance } = await import("@openedx/openedx-ai-extensions-ui");
      addPlugins(config, 'org.openedx.frontend.learning.unit_title.v1', [
          {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'ai-assist-button',
                priority: 10,
                type: DIRECT_PLUGIN,
                RenderWidget: ConfigurableAIAssistance,
            },
          }]);
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
    if (process.env.APP_ID == 'catalog') {
    }
    if (process.env.APP_ID == 'learner-record') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;